// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stewarding-container {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  overflow-y: auto;
  padding: 16px;
  background-color: #0f172a;
  box-sizing: border-box;
}

.stewarding-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.stewarding-header h3 {
  margin: 0;
  font-size: 20px;
  color: #f8fafc;
}

.stewarding-header p {
  margin: 4px 0 0;
  color: #94a3b8;
  font-size: 13px;
}

.stewarding-grid {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 16px;
  overflow: visible;
}

.stewarding-panel {
  background-color: #111827;
  border: 1px solid #334155;
  border-radius: 12px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
}

.stewarding-panel h4 {
  margin: 0;
  color: #e2e8f0;
  font-size: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  color: #94a3b8;
  font-size: 13px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  background-color: #0f172a;
  color: #f8fafc;
  border: 1px solid #334155;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
}

.form-group textarea {
  min-height: 100px;
  resize: vertical;
}

.form-actions {
  display: flex;
  justify-content: flex-start;
}

.add-button,
.remove-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: 1px solid transparent;
  border-radius: 8px;
  background-color: #1d4ed8;
  color: #f8fafc;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
}

.add-button:hover,
.remove-button:hover {
  background-color: #2563eb;
}

.remove-button {
  background-color: #dc2626;
}

.remove-button:hover {
  background-color: #ef4444;
}

.stewarding-error,
.stewarding-success {
  padding: 12px 14px;
  border-radius: 8px;
  font-size: 13px;
}

.stewarding-error {
  background-color: rgba(248, 113, 113, 0.15);
  border: 1px solid #fca5a5;
  color: #fecaca;
}

.stewarding-success {
  background-color: rgba(34, 197, 94, 0.15);
  border: 1px solid #86efac;
  color: #bbf7d0;
}

.penalties-list {
  display: grid;
  gap: 12px;
  overflow: auto;
  min-height: 0;
}

.empty-state {
  color: #94a3b8;
  font-size: 14px;
}

.penalty-card {
  background-color: #0f172a;
  border: 1px solid #334155;
  border-radius: 12px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.penalty-meta {
  display: grid;
  gap: 10px;
}

.penalty-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  color: #cbd5e1;
  font-size: 13px;
}

.penalty-label {
  color: #94a3b8;
  font-weight: 600;
}

.penalty-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.penalty-reason {
  color: #f8fafc;
  font-size: 13px;
  flex: 1 1;
}

@media (max-width: 900px) {
  .stewarding-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Stewarding.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,oDAAoD;AACtD;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAO;AACT;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".stewarding-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  height: 100%;\r\n  overflow-y: auto;\r\n  padding: 16px;\r\n  background-color: #0f172a;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.stewarding-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.stewarding-header h3 {\r\n  margin: 0;\r\n  font-size: 20px;\r\n  color: #f8fafc;\r\n}\r\n\r\n.stewarding-header p {\r\n  margin: 4px 0 0;\r\n  color: #94a3b8;\r\n  font-size: 13px;\r\n}\r\n\r\n.stewarding-grid {\r\n  display: grid;\r\n  grid-template-columns: 1.2fr 1fr;\r\n  gap: 16px;\r\n  overflow: visible;\r\n}\r\n\r\n.stewarding-panel {\r\n  background-color: #111827;\r\n  border: 1px solid #334155;\r\n  border-radius: 12px;\r\n  padding: 18px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  min-height: 0;\r\n}\r\n\r\n.stewarding-panel h4 {\r\n  margin: 0;\r\n  color: #e2e8f0;\r\n  font-size: 16px;\r\n}\r\n\r\n.form-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.form-group label {\r\n  color: #94a3b8;\r\n  font-size: 13px;\r\n}\r\n\r\n.form-group input,\r\n.form-group select,\r\n.form-group textarea {\r\n  width: 100%;\r\n  background-color: #0f172a;\r\n  color: #f8fafc;\r\n  border: 1px solid #334155;\r\n  border-radius: 8px;\r\n  padding: 10px 12px;\r\n  font-size: 14px;\r\n}\r\n\r\n.form-group textarea {\r\n  min-height: 100px;\r\n  resize: vertical;\r\n}\r\n\r\n.form-actions {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.add-button,\r\n.remove-button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 16px;\r\n  border: 1px solid transparent;\r\n  border-radius: 8px;\r\n  background-color: #1d4ed8;\r\n  color: #f8fafc;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s, border-color 0.2s;\r\n}\r\n\r\n.add-button:hover,\r\n.remove-button:hover {\r\n  background-color: #2563eb;\r\n}\r\n\r\n.remove-button {\r\n  background-color: #dc2626;\r\n}\r\n\r\n.remove-button:hover {\r\n  background-color: #ef4444;\r\n}\r\n\r\n.stewarding-error,\r\n.stewarding-success {\r\n  padding: 12px 14px;\r\n  border-radius: 8px;\r\n  font-size: 13px;\r\n}\r\n\r\n.stewarding-error {\r\n  background-color: rgba(248, 113, 113, 0.15);\r\n  border: 1px solid #fca5a5;\r\n  color: #fecaca;\r\n}\r\n\r\n.stewarding-success {\r\n  background-color: rgba(34, 197, 94, 0.15);\r\n  border: 1px solid #86efac;\r\n  color: #bbf7d0;\r\n}\r\n\r\n.penalties-list {\r\n  display: grid;\r\n  gap: 12px;\r\n  overflow: auto;\r\n  min-height: 0;\r\n}\r\n\r\n.empty-state {\r\n  color: #94a3b8;\r\n  font-size: 14px;\r\n}\r\n\r\n.penalty-card {\r\n  background-color: #0f172a;\r\n  border: 1px solid #334155;\r\n  border-radius: 12px;\r\n  padding: 14px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.penalty-meta {\r\n  display: grid;\r\n  gap: 10px;\r\n}\r\n\r\n.penalty-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  color: #cbd5e1;\r\n  font-size: 13px;\r\n}\r\n\r\n.penalty-label {\r\n  color: #94a3b8;\r\n  font-weight: 600;\r\n}\r\n\r\n.penalty-footer {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.penalty-reason {\r\n  color: #f8fafc;\r\n  font-size: 13px;\r\n  flex: 1;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .stewarding-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
